import React from 'react';
import CardContainer from '../cardContainer/CardContainer';

const PrincipalContainer = () => {
  	return (
    	<section className="principal-container">
            <CardContainer />
    	</section>
  	);
}

export default PrincipalContainer;
